import React from 'react';
import PropTypes from 'prop-types';

import CountBadge from "./components/CountBadge";
import IconContainer from "./components/IconContainer";

import {ReactComponent as CustomerCommentSvg} from "assets/img/customer-comment.svg";
import {ReactComponent as InternalNoteSvg} from "assets/img/internalNote-green.svg";

OrderNotes.propTypes = {
    customerCommentCount: PropTypes.number,
    internalNoteCount: PropTypes.number
};

function OrderNotes({customerCommentCount = 0, internalNoteCount = 0}) {
    return (
        <div style={{
            display: 'flex',
            flexDirection: 'column',
            gap: '8px',
            alignItems: 'center'
        }}>
            {customerCommentCount > 0 && (
                <IconContainer>
                    <CountBadge count={customerCommentCount} />
                    <CustomerCommentSvg />
                </IconContainer>
            )}
            {internalNoteCount > 0 && (
                <IconContainer>
                    <CountBadge count={internalNoteCount} />
                    <InternalNoteSvg />
                </IconContainer>
            )}
        </div>
    );
}

export default OrderNotes;
